/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import ReactPlayer from 'react-player';
import classNames from 'classnames';
import { BASE_URL, IMAGE_PATHS, VIDEO_PATHS } from '../../../../constants/paths.constants';
import { yellow, universalStyles } from '../../../../app/theme';

const useStyles = makeStyles(() => ({
  ...universalStyles,
  container: {
    width: 'calc(100% + 160px)',
    display: 'flex',
    flexDirection: 'row',
  },
  columnContainer: {
    width: '50%',
    marginRight: '1%',
  },
  column0: {
    width: '3%',
  },
  column1: {
    width: '40%',
    marginRight: '2%',
  },
  column2: {
    width: '58%',
  },
  column3: {
    width: '49%',
  },
  image: {
    width: '100%',
  },
  smallImage: {
    width: '50%',
    marginLeft: '25%',
  },
  video: {
    maxHeight: 435,
    aspectRatio: '.48',
    marginLeft: 'auto',
    marginRight: 'auto',
    display: 'block',
  },
  figureBox: {
    border: `2px solid ${yellow}`,
    width: '100%',
    boxSizing: 'border-box',
    padding: '3px 5px',
    margin: '5px 0 10px',
  },
  row: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
  },
  key: {
    width: '70%',
    marginLeft: 15,
  },
  text: {
    fontSize: 16,
    lineHeight: 1.2,
  },
}));

const Acquisition01 = (): JSX.Element => {
  const classes = useStyles();

  return (
    <>
      <div className={classes.container}>
        <div className={classes.columnContainer}>
          <div className={classes.row}>
            <div className={classes.column0}>
              <img src={`${BASE_URL}${IMAGE_PATHS.SUV.path}`} alt={IMAGE_PATHS.SUV.alt} />
            </div>
            <div className={classes.column1}>
              <div className={classes.video}>
                <ReactPlayer className={classes.responsiveVideo} url={VIDEO_PATHS.ACQ_CASE_STUDY_1.path} controls />
              </div>
            </div>
            <div className={classes.column2}>
              <img
                className={classes.image}
                src={`${BASE_URL}${IMAGE_PATHS.PET_CORONAL.path}`}
                alt={IMAGE_PATHS.PET_CORONAL.alt}
              />
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.column0} />
            <div className={classes.column1}>
              <div className={classes.figureBox}>
                <Typography variant="body1" className={classes.text}>
                  <b>Fig 1: </b>
                  MIP (Click to Play)
                </Typography>
              </div>
            </div>
            <div className={classes.column2}>
              <div className={classes.figureBox}>
                <Typography variant="body1" className={classes.text}>
                  <b>Fig 2: </b>
                  Retroperitoneal malignant nodes (PET coronal)
                </Typography>
              </div>
            </div>
          </div>
        </div>
        <div className={classes.column3}>
          <img
            className={classes.smallImage}
            src={`${BASE_URL}${IMAGE_PATHS.PET_CT_TRANSAXIAL.path}`}
            alt={IMAGE_PATHS.PET_CT_TRANSAXIAL.alt}
          />
          <div className={classes.figureBox}>
            <Typography variant="body1" className={classes.text}>
              <b>Fig 3: </b>
              Retroperitoneal malignant node (PET/CT transaxial) (top image)
            </Typography>
            <Typography variant="body1" className={classNames(classes.text, classes.row)}>
              <span className={classes.key}>
                Lymph Node SUV(bw)
                <sub>max</sub>:
              </span>
              8.3
            </Typography>
            <Typography variant="body1" className={classNames(classes.text, classes.row)}>
              <span className={classes.key}>Lymph Node short axis:</span>
              1.2 cm
            </Typography>
            <Typography variant="body1" className={classNames(classes.text, classes.row)}>
              <span className={classes.key}>
                Marrow (L3) SUV(bw)
                <sub>mean</sub>:
              </span>
              4.0
            </Typography>
            <Typography variant="body1" className={classes.text}>
              <b>Fig 4: </b>
              Thoracic malignant node (PET/CT transaxial) (bottom image)
            </Typography>
            <Typography variant="body1" className={classNames(classes.text, classes.row)}>
              <span className={classes.key}>
                Lymph Node SUV(bw)
                <sub>max</sub>:
              </span>
              6.0
            </Typography>
            <Typography variant="body1" className={classNames(classes.text, classes.row)}>
              <span className={classes.key}>Lymph Node short axis:</span>
              0.6 cm
            </Typography>
            <Typography variant="body1" className={classNames(classes.text, classes.row)}>
              <span className={classes.key}>
                Blood Pool (Aorta) SUV(bw)
                <sub>mean</sub>:
              </span>
              1.4
            </Typography>
          </div>
        </div>
      </div>
    </>
  );
};

export default Acquisition01;
